export const msalConfig = {
  auth: {
    clientId: "ff429228-135f-4320-a601-a561c1c87019",
    authority:
      "https://login.microsoftonline.com/73a99466-ad05-4221-9f90-e7142aa2f6c1",
    redirectUri: process.env.REACT_APP_OAUTH_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (
        level: unknown,
        message: unknown,
        containsPii: unknown
      ) => {
        if (containsPii) {
          return;
        }
      },
    },
  },
};

export const selfServiceApiScopes = [
  "api://ff429228-135f-4320-a601-a561c1c87019/api-access",
];
